import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, useMediaQuery, useTheme } from '@mui/material'
import { useSnackbar } from 'notistack'
import { FormEvent, useContext, useState } from 'react'
import { EbAuthenticatedAppContext } from '@eidsivabredband/app-framework'
import DialogCloseButton from '../../../components/Buttons/DialogCloseButton'
import MonoInputField from '../../../components/InputFields/MonoInputField'
import { LoadingIndicator } from '@eidsivabredband/react-component-ui-package'

interface CreatePostProps {
  eventId: string
  open: boolean
  onClose: () => void
  onCreate: () => void
}

function CreatePost({ eventId, open, onClose, onCreate }: CreatePostProps) {
  const [postContent, setPostContent] = useState<string>('')
  const { enqueueSnackbar } = useSnackbar()
  const { context } = useContext(EbAuthenticatedAppContext)
  const theme = useTheme()
  const smXsDown = useMediaQuery(theme.breakpoints.down('sm'))
  const [sendLoading, setSendLoading] = useState(false)

  const handleOnClose = () => {
    setPostContent('')
    onClose()
  }

  const handleCreatePost = async (e: FormEvent<HTMLFormElement>) => {
    setSendLoading(true)

    e.preventDefault()

    const response = await context.restApiClient.buildRequest(`/api/event/${eventId}/add-post`).serializeToJsonContent(postContent).postAsync()

    if (response.error) {
      enqueueSnackbar(<Typography variant="body2">Kunne ikke lagre melding. Prøv igjen eller kontakt systemansvarlig.</Typography>, {
        variant: 'error',
      })

      return setSendLoading(false)
    } else {
      setPostContent('')
      onCreate()
      return setSendLoading(false)
    }
  }

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="md"
      fullScreen={smXsDown}
      scroll={'paper'}
      sx={{
        '& .MuiPaper-root': {
          borderRadius: '8px',
          backgroundColor: 'background.default',
        },
      }}
    >
      <DialogTitle>
        <Typography variant="body1">Ny melding</Typography>
        <DialogCloseButton handleClose={handleOnClose} />
      </DialogTitle>
      <form
        onSubmit={handleCreatePost}
        style={{
          display: 'contents',
        }}
      >
        <DialogContent dividers={true}>
          <MonoInputField
            name="Melding"
            placeholder="Skriv melding"
            variant="outlined"
            value={postContent}
            onChange={(e) => setPostContent(e.target.value)}
            multiline
            rows={20}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleOnClose} variant="contained" color="error" disabled={sendLoading}>
            Avbryt
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={sendLoading || postContent.length === 0}
            startIcon={sendLoading ? <LoadingIndicator size={'xsmall'} /> : null}
          >
            Send
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default CreatePost
